import { useNavigate, useParams } from "react-router-dom";
import { EditSchedulePage as EditSchedulePageView } from "@/components/EditSchedulePage";

export function EditSchedulePage() {
  const navigate = useNavigate();
  const { scheduleId } = useParams<{ scheduleId: string }>();

  if (!scheduleId) return null;

  return (
    <EditSchedulePageView
      scheduleId={scheduleId}
      onSaved={(id) => navigate(`/schedules/${id}`)}
      onCancel={() => navigate(`/schedules/${scheduleId}`)}
    />
  );
}
